import React from 'react'

// 手機錨底 ad
export default function AmpArticleStickyAd({ isR18Article, isLoveSite }) {
  const getAdSlot = () => {
    if (isR18Article) return '/90969475/amp_mobile_18adult_article_anchor'
    if (isLoveSite) return '/90969475/amp_mobile_love_article_anchor'
    return '/90969475/amp_mobile_article_anchor'
  }

  return (
    <amp-sticky-ad layout="nodisplay">
      <amp-ad
        width="320"
        height="100"
        type="doubleclick"
        data-slot={getAdSlot()}
        data-multi-size="320x70"
      />
    </amp-sticky-ad>
  )
}
